module.exports = __webpack_public_path__ + "static/img/BD@3x.f535abf8.jpg";